import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a4aabc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-header" }
const _hoisted_2 = { style: {"font-size":"22px"} }
const _hoisted_3 = { class: "notice-stats-detail" }
const _hoisted_4 = { class: "search-form" }

import { ref, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { getListData, downloadData } from '@/service/main/system'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'tablist',
  setup(__props, { expose: __expose }) {

const dialogVisible = ref(false)
const currentRow = ref<any>(null)
const tableData = ref<any[]>([])
const searchForm = ref({
  empName: ''
})

const dialogTitle = computed(() => {
  if (currentRow.value && currentRow.value.name) {
    return currentRow.value.name
  }
  return '售后通知阅读记录详情'
})

/**
 * 获取状态颜色
 */
const getStatusColor = (status: string) => {
  if (status === '已读') {
    return '#67c23a'
  } else if (status === '未读') {
    return '#f56c6c'
  }
  return '#909399'
}

/**
 * 打开弹窗
 */
const open = (row: any) => {
  currentRow.value = row
  dialogVisible.value = true
  searchForm.value = {
    empName: ''
  }
  loadData()
}

/**
 * 关闭弹窗
 */
const handleClose = () => {
  dialogVisible.value = false
  tableData.value = []
  currentRow.value = null
  searchForm.value = {
    empName: ''
  }
}

/**
 * 加载数据
 */
const loadData = async () => {
  try {
    const params: any = {
      targetDate: currentRow.value?.date
    }

    if (searchForm.value.empName) {
      params.empName = searchForm.value.empName
    }

    // 售后接口
    const res = await getListData('/main/notice-stats/getAllAfterSalesEmpNoticeStatsSummary', params)

    if (res && Array.isArray(res)) {
      tableData.value = res
    } else {
      tableData.value = []
    }
  } catch (error) {
    console.error('加载数据失败:', error)
    ElMessage.error('数据加载失败')
  }
}

/**
 * 查询
 */
const handleSearch = () => {
  loadData()
}

/**
 * 重置
 */
const resetSearch = () => {
  searchForm.value = {
    empName: ''
  }
  loadData()
}

/**
 * 下载
 */
const handleDownload = async () => {
  try {
    const params: any = {
      targetDate: currentRow.value?.date
    }

    if (searchForm.value.empName) {
      params.empName = searchForm.value.empName
    }

    // 售后下载接口 (GET)
    const res = await downloadData('/main/notice-stats/exportAllAfterSalesEmpNoticeStatsSummary', params, 'blob')

    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = `售后通知阅读记录_${dayjs().format('YYYY-MM-DD HH:mm:ss')}.xlsx`
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)

    ElMessage.success('下载成功')
  } catch (error) {
    console.error('下载失败:', error)
    ElMessage.error('下载失败，请重试')
  }
}

__expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    fullscreen: true,
    "show-close": false
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(dialogTitle.value), 1),
        _createVNode(_component_el_button, {
          type: "danger",
          icon: "el-icon-close",
          size: "small",
          onClick: handleClose,
          style: {"position":"absolute","top":"0","right":"10px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 关闭 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            inline: true,
            model: searchForm.value,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "业务员姓名：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: searchForm.value.empName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.value.empName) = $event)),
                    placeholder: "请输入业务员姓名",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: handleSearch
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查询")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: resetSearch }, {
                    default: _withCtx(() => [
                      _createTextVNode("重置")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "success",
                    onClick: handleDownload
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("下载")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createVNode(_component_el_table, {
          data: tableData.value,
          border: "",
          style: {"width":"100%"},
          "max-height": "600"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "empName",
              label: "姓名",
              width: "100",
              fixed: "left"
            }),
            _createVNode(_component_el_table_column, {
              prop: "deptName",
              label: "组别",
              width: "150",
              fixed: "left"
            }),
            _createVNode(_component_el_table_column, {
              label: "直播间定金订单客户信息",
              "min-width": "170"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.afterSalesDepositOrderStatus) })
                }, _toDisplayString(scope.row.afterSalesDepositOrderStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "敏感词预警",
              "min-width": "120"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.afterSalesSensitiveWordsStatus) })
                }, _toDisplayString(scope.row.afterSalesSensitiveWordsStatus || '无'), 5)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})